import { AppRouteProps } from "@harea/component";
import React from "react";
import { DeclarationAuthorityKey } from "./types/TDeclaration";

const DeclarationListContainer = React.lazy(() => import("./container/DeclarationListContainer"));
const DeclarationDnsListContainer = React.lazy(() => import("./container/DeclarationDnsListContainer"));

const authorityRoutes = (
    key: DeclarationAuthorityKey,
    slug: string,
    title: string,
): AppRouteProps => ({
    path: `declarations/${slug}`,
    element: <DeclarationDnsListContainer authorityKey={key} />,
    title,
});

export const DeclarationRoutes = [
    {
        path: "declarations",
        element: <DeclarationListContainer />,
        title: "std_declaration",
    },
    authorityRoutes("SOCIAL_SECURITY", "social-security", "std_declaration_sociale"),
    authorityRoutes("HEALTH_INSURANCE", "health-insurance", "std_declaration_sante"),
    authorityRoutes("TAX", "tax", "std_declaration_impot"),
    authorityRoutes("FORMATION", "formation", "std_declaration_formation"),
] as Array<AppRouteProps>;
